module.exports = "/assets/data/fba9e274940b00b3bc760c9d2e518543-SW12.data.json";